import __request__ from "routing/request";
export function exportZip(id, requestOptions) {
  return __request__("GET", "/events/definitions/yaml", null, { "id": id }, {
    "Accept": ["application/zip"]
  }, requestOptions);
}
export function exportZipByBody(JSONbody, requestOptions) {
  return __request__("POST", "/events/definitions/yaml/export", JSONbody, {}, {
    "Accept": ["application/zip"]
  }, requestOptions);
}
export function importFiles(dry_run = false, body, requestOptions) {
  return __request__("POST", "/events/definitions/yaml/import", body, { "dry_run": dry_run }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function exportOne(definitionId, requestOptions) {
  return __request__("GET", `/events/definitions/yaml/${definitionId}`, null, {}, {
    "Accept": ["application/yaml"]
  }, requestOptions);
}
